import { render, staticRenderFns } from "./PreRegister.vue?vue&type=template&id=05bb07fa&scoped=true"
import script from "./PreRegister.vue?vue&type=script&lang=js"
export * from "./PreRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bb07fa",
  null
  
)

export default component.exports